const permissionErrors = Object.freeze([
  'error.connect.facebook.missing_permissions',
  'error.connect.google.permission_denied',
])

// The `_leadForm` variants are separate keys; without a suffix the plain
// `platformIssues`/`permissions` keys are the ones that exist.
const errorKey = (name, suffix) =>
  `Recommendations.campaign.errors.${suffix ? `${name}_${suffix}` : name}`

// Translation key for a connect error code. Anything that isn't a known
// permission failure falls back to the generic "couldn't retrieve data"
// message, so an unmapped code can't render an empty error line.
export const getErrorText = (error, suffix = '') => {
  if (!error) return undefined
  return permissionErrors.includes(error)
    ? errorKey('permissions', suffix)
    : errorKey('platformIssues', suffix)
}
